// extracted by mini-css-extract-plugin
export default {"emptyStateContainer":"AssignClassSettingsDataGrid__emptyStateContainer___oKpkE"};